/**
 * Reconnaître un COMPTE RESSOURCE Teams (file d'attente, standard automatique, flux) parmi les
 * résultats d'une recherche Graph.
 *
 * Pourquoi ça compte ici : une action « transfer » d'un flux porte un `targetType` que le moteur
 * traduit en identifiant ACS. Trois valeurs sont possibles — `phone`, `user`, `app` — et se
 * tromper ne produit AUCUNE erreur visible. Un compte ressource envoyé comme `user` devient un
 * `microsoftTeamsUserId` bien formé désignant un utilisateur qui n'existe pas : ACS accepte la
 * requête, le transfert ne sonne jamais.
 *
 * ─────────────────────────────────────────────────────────────────────────────────────────────
 * LE MARQUEUR
 *
 * Entra ID ne donne pas de champ franc : ni `userType` (« Member », comme un humain) ni
 * `accountEnabled` ne séparent un compte ressource d'un utilisateur. Teams pose en revanche son
 * propre `department` sur toute *application instance* :
 *
 *     {
 *       "displayName": "Nopea Transport",
 *       "department": "Microsoft Communication Application Instance",
 *       "accountEnabled": false,
 *       "userType": "Member"
 *     }
 *
 * La console agent applique exactement le même test (`AgentConsole/src/services/transferTarget.js`)
 * pour ses transferts. Les deux doivent rester d'accord : un compte que l'une reconnaît et pas
 * l'autre donnerait un transfert qui marche depuis un côté et pas depuis l'autre.
 *
 * ⚠️ `department` doit être demandé explicitement dans le `$select` de la requête Graph. Sans
 * lui, le champ est absent et TOUT compte ressource passe pour un utilisateur — silencieusement.
 * Voir `GRAPH_ENDPOINTS.SEARCH_USERS`.
 */

export const RESOURCE_ACCOUNT_DEPARTMENT = "Microsoft Communication Application Instance";

/** Ce résultat de recherche Graph est-il un compte ressource ? */
export function isResourceAccount(resource) {
    return resource?.department === RESOURCE_ACCOUNT_DEPARTMENT;
}

/**
 * `targetType` à enregistrer pour une cible de transfert NON téléphonique.
 *
 * @param {object} resource  résultat Graph (doit porter `department`)
 * @returns {"app"|"user"}
 */
export function transferTargetTypeFor(resource) {
    return isResourceAccount(resource) ? "app" : "user";
}
